import { faPlus, faSpinner, faWarning } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { Alert, Button, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../../../App";
import UserPass from "../../../../components/passes/UserPass";
import { postMethod } from "../../../../requests";
import { UDContext } from "./UserDetails";

const UserDetailsPasses = () => {
    const { t } = useTranslation();
    const { showView, checkServerData, changeView } = useContext(BasicContext);
    const [activePasses, setActivePasses] = useState(null);
    const [restPasses, setRestPasses] = useState(null);
    const [userPassesAlert, setUserPassesAlert] = useState(null);
    const [loading, setLoading] = useState(true);
    const { reloadData } = useContext(UDContext);

    const getUserPasses = async () => {
        const res = await postMethod("/get-user-passes", { userID: showView.params.userID });
        if (checkServerData(res)) {
            if (res.data.alert) {
                setUserPassesAlert({
                    variant: "warning",
                    message: (
                        <>
                            <FontAwesomeIcon icon={faWarning} className="me-2" />
                            {t("warning.userHasTooMuchNotPaidActivePasses")}
                        </>
                    ),
                });
            }
            setActivePasses(res.data.activePasses);
            setRestPasses(res.data.restPasses);
        } else setLoading(false);
    };

    const reload = () => {
        setLoading(true);
        setTimeout(() => {
            getUserPasses();
        }, 200);
    };

    useEffect(() => {
        if (activePasses && restPasses && loading) setLoading(false);
        // eslint-disable-next-line
    }, [activePasses, restPasses]);

    useEffect(() => {
        getUserPasses();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            {loading ? (
                <Col className="text-center">
                    <FontAwesomeIcon icon={faSpinner} className="rotate-center" />
                </Col>
            ) : (
                <Fragment>
                    {userPassesAlert && <Alert variant={userPassesAlert.variant}>{userPassesAlert.message}</Alert>}
                    {activePasses && (
                        <Row>
                            <Col xs={8} lg={6} className="ps-4">
                                <p className="h6 my-3">{t("passes.activePasses")}</p>
                            </Col>
                            <Col xs={4} lg={6} className="pe-4 text-end">
                                <OverlayTrigger placement="bottom" delay={{ show: 150, hide: 100 }} overlay={<Tooltip id={`addPassToUser`}>{t("passes.addPassToUser")}</Tooltip>}>
                                    <Button
                                        variant="outline-primary"
                                        className="me-2 my-lg-3 mb-3 mt-2"
                                        size="sm"
                                        onClick={() => changeView({ nav: "passes", sub: "addPassToUser", params: { userID: showView.params.userID } })}
                                        style={{ marginTop: "-6px" }}
                                    >
                                        <FontAwesomeIcon icon={faPlus} className="me-lg-2 me-0" />
                                        <span className="d-none d-lg-inline">{t("passes.addPassToUser")}</span>
                                    </Button>
                                </OverlayTrigger>
                            </Col>
                            {activePasses.length === 0 ? (
                                <p className="opacity-75 fs-6 text-center">{t("passes.noActivePasses")}</p>
                            ) : (
                                <Col xs={12} className="">
                                    <Table className="mb-3 white-table">
                                        <tbody>
                                            {activePasses.map((e, i) => (
                                                <Fragment key={i}>
                                                    <UserPass pass={e} reload={reload} adminView reloadData={(v) => reloadData(v)} />
                                                </Fragment>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                            )}
                        </Row>
                    )}
                    {restPasses && (
                        <Fragment>
                            <Col xs={12} className="px-4">
                                <p className="h6 mb-3">{t("passes.historyPasses")}</p>
                            </Col>
                            {restPasses.length === 0 ? (
                                <p className="opacity-75 fs-6 text-center">{t("passes.noRestPasses")}</p>
                            ) : (
                                <Col xs={12} className="px-0 px-lg-2">
                                    <Table size="sm" className="mb-3 white-table">
                                        <tbody>
                                            {restPasses.map((e, i) => (
                                                <Fragment key={i}>
                                                    <UserPass pass={e} reload={reload} adminView reloadData={(v) => reloadData(v)} />
                                                </Fragment>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                            )}
                        </Fragment>
                    )}
                </Fragment>
            )}
        </Fragment>
    );
};

export default UserDetailsPasses;
